export default "__VITE_ASSET__mP0qKZCC__"